import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import { createContext, useContext, useEffect } from "react";
import useStore from "../common/useStore";
import TonClientStore from "./TonClientStore";

const TonClientStoreContext = createContext<TonClientStore | undefined>(
  undefined
);

export interface TonClientStoreProviderProps {
  children: React.ReactNode;
}

export const TonClientStoreProvider = ({
  children,
}: TonClientStoreProviderProps): JSX.Element => {
  const [tonConnectUI] = useTonConnectUI();
  // const clientEndpoint = useMemo(() => "https://mainnet-v4.tonhubapi.com", []);
  const userAddress = useTonAddress();
  const tonClientStore = useStore(TonClientStore, []);

  useEffect(() => {
    const loadTonClients = async () => {
      await Promise.allSettled([
        tonClientStore.loadClient(true),
        tonClientStore.loadClient4(true),
        tonClientStore.loadSender(tonConnectUI),
      ]);
    };

    loadTonClients();
  }, [tonClientStore, tonConnectUI]);

  useEffect(() => {
    const loadWalletVersion = async () => {
      await tonClientStore.loadWalletVersion(userAddress);
    };

    loadWalletVersion();
  }, [userAddress]);

  // useEffect(() => {
  //   tonClientStore.loadTonBalance(userAddress);
  //   tonClientStore.loadRaffBalance(userAddress);
  //   tonClientStore.loadUsdtBalance(userAddress);
  // }, [userAddress]);

  return (
    <TonClientStoreContext.Provider value={tonClientStore}>
      {children}
    </TonClientStoreContext.Provider>
  );
};

const useTonClientStore = () => {
  const store = useContext(TonClientStoreContext);

  if (!store)
    throw new Error(
      "useTonClientStore should be called inside TonClientStoreProvider"
    );

  return store;
};

export default useTonClientStore;
